import { shuffle } from './lib';
import { generateConfig } from './generate-config';

const s2 = (a, seed) => shuffle(shuffle(a, seed), seed);

const generatePairs = (level, shuffler = s2) => {
  let result = [];

  level.pairs.forEach(({
    count, typeA, typeB
  }) => {
    result = [...result, ...generateConfig(count, typeA, typeB, shuffler)];
  });

  return shuffler(result);
};

export default generatePairs;
